/**
 * @generated SignedSource<<e67b634effab69a1a0b6d2cc6bb3e4ad>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type B2ClockSessionPaymentStatus = "COMPLETED" | "REQUIRES_ACTION" | "REQUIRES_CAPTURE" | "%future added value";
export type SpaceConfiguration = "BACE_CLATTERING_STANDARD" | "BACE_SATELLITE_LARGE_EXTENDED" | "BACE_SATELLITE_LARGE_STANDARD" | "BACE_SATELLITE_MEDIUM_EXTENDED" | "BACE_SATELLITE_MEDIUM_STANDARD" | "BACE_SATELLITE_SMALL_EXTENDED" | "BACE_SATELLITE_SMALL_SLIM" | "BACE_SATELLITE_SMALL_STANDARD" | "BACE_STOREFRONT_2XL" | "BACE_STOREFRONT_L" | "BACE_STOREFRONT_M" | "BACE_STOREFRONT_S" | "BACE_STOREFRONT_XL" | "BACE_TRUCK_HUB_STANDARD" | "THALIA_RENZ_STANDARD_M" | "THALIA_RENZ_STANDARD_S" | "THALIA_RENZ_STANDARD_XS" | "THALIA_RENZ_WIDE_M" | "THALIA_RENZ_WIDE_S" | "%future added value";
export type ended_reservationIdQuery$variables = {
  hubName: string;
  reservationId: string;
};
export type ended_reservationIdQuery$data = {
  readonly b2CLockSession: {
    readonly amountCollected: number;
    readonly dailyCeiling: any;
    readonly finalAmount: number | null | undefined;
    readonly hourlyRate: any;
    readonly id: string;
    readonly startFee: any;
    readonly weekCeiling: any;
  } | null | undefined;
  readonly hubMeta: {
    readonly city: string;
    readonly hub: {
      readonly id: string;
    };
    readonly id: string;
    readonly name: string;
    readonly postalCode: string;
    readonly street: string;
  };
  readonly reservation: {
    readonly contentNote?: string | null | undefined;
    readonly createdAt?: any;
    readonly deactivatedAt?: any | null | undefined;
    readonly id?: string;
    readonly note?: string | null | undefined;
    readonly space?: {
      readonly configuration: SpaceConfiguration;
      readonly dimensions: {
        readonly depthMm: number;
        readonly heightMm: number;
        readonly widthMm: number;
      };
      readonly frame: string;
      readonly hub: {
        readonly id: string;
      };
      readonly id: string;
      readonly position: number;
    };
    readonly startedAt?: any;
    readonly subtype?: {
      readonly __typename: "B2ClockReservationSubtype";
      readonly b2CLockSession: {
        readonly amountCollected: number;
        readonly finalAmount: number | null | undefined;
        readonly paymentStatus: B2ClockSessionPaymentStatus | null | undefined;
      };
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    };
  } | null | undefined;
};
export type ended_reservationIdQuery = {
  response: ended_reservationIdQuery$data;
  variables: ended_reservationIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hubName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "reservationId"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "hubName"
      }
    ],
    "kind": "ObjectValue",
    "name": "by"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "street",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postalCode",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Hub",
  "kind": "LinkedField",
  "name": "hub",
  "plural": false,
  "selections": [
    (v2/*:: as any*/)
  ],
  "storageKey": null
},
v8 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "reservationId"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "finalAmount",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amountCollected",
  "storageKey": null
},
v12 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "deactivatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentNote",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "note",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "subtype",
      "plural": false,
      "selections": [
        (v9/*:: as any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "B2ClockSession",
              "kind": "LinkedField",
              "name": "b2CLockSession",
              "plural": false,
              "selections": [
                (v10/*:: as any*/),
                (v11/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "paymentStatus",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "B2ClockReservationSubtype",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "space",
      "plural": false,
      "selections": [
        (v2/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "frame",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "position",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "configuration",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "OutputDimensions",
          "kind": "LinkedField",
          "name": "dimensions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "widthMm",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "heightMm",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "depthMm",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v7/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "LockReservation",
  "abstractKey": null
},
v13 = {
  "alias": null,
  "args": [
    {
      "fields": [
        {
          "kind": "Variable",
          "name": "reservationId",
          "variableName": "reservationId"
        }
      ],
      "kind": "ObjectValue",
      "name": "by"
    }
  ],
  "concreteType": "B2ClockSession",
  "kind": "LinkedField",
  "name": "b2CLockSession",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startFee",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hourlyRate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dailyCeiling",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "weekCeiling",
      "storageKey": null
    },
    (v10/*:: as any*/),
    (v11/*:: as any*/)
  ],
  "storageKey": null
},
v14 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "Int"
},
v15 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "Decimal"
},
v16 = {
  "enumValues": null,
  "nullable": true,
  "plural": false,
  "type": "Int"
},
v17 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "UUID"
},
v18 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "String"
},
v19 = {
  "enumValues": null,
  "nullable": true,
  "plural": false,
  "type": "String"
},
v20 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "DateTime"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ended_reservationIdQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*:: as any*/),
          "concreteType": "HubMeta",
          "kind": "LinkedField",
          "name": "hubMeta",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            (v3/*:: as any*/),
            (v4/*:: as any*/),
            (v5/*:: as any*/),
            (v6/*:: as any*/),
            {
              "kind": "RequiredField",
              "field": (v7/*:: as any*/),
              "action": "THROW"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      },
      {
        "alias": null,
        "args": (v8/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "reservation",
        "plural": false,
        "selections": [
          (v12/*:: as any*/)
        ],
        "storageKey": null
      },
      (v13/*:: as any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "ended_reservationIdQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "HubMeta",
        "kind": "LinkedField",
        "name": "hubMeta",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          (v7/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v8/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "reservation",
        "plural": false,
        "selections": [
          (v9/*:: as any*/),
          (v12/*:: as any*/)
        ],
        "storageKey": null
      },
      (v13/*:: as any*/)
    ]
  },
  "params": {
    "cacheID": "c8af7a4c9b4402b5a9504897434f194d",
    "id": null,
    "metadata": {
      "relayTestingSelectionTypeInfo": {
        "b2CLockSession": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "B2ClockSession"
        },
        "b2CLockSession.amountCollected": (v14/*:: as any*/),
        "b2CLockSession.dailyCeiling": (v15/*:: as any*/),
        "b2CLockSession.finalAmount": (v16/*:: as any*/),
        "b2CLockSession.hourlyRate": (v15/*:: as any*/),
        "b2CLockSession.id": (v17/*:: as any*/),
        "b2CLockSession.startFee": (v15/*:: as any*/),
        "b2CLockSession.weekCeiling": (v15/*:: as any*/),
        "hubMeta": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "HubMeta"
        },
        "hubMeta.city": (v18/*:: as any*/),
        "hubMeta.hub": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "Hub"
        },
        "hubMeta.hub.id": (v17/*:: as any*/),
        "hubMeta.id": (v17/*:: as any*/),
        "hubMeta.name": (v18/*:: as any*/),
        "hubMeta.postalCode": (v18/*:: as any*/),
        "hubMeta.street": (v18/*:: as any*/),
        "reservation": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "Reservation"
        },
        "reservation.__typename": (v18/*:: as any*/),
        "reservation.contentNote": (v19/*:: as any*/),
        "reservation.createdAt": (v20/*:: as any*/),
        "reservation.deactivatedAt": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "DateTime"
        },
        "reservation.id": (v17/*:: as any*/),
        "reservation.note": (v19/*:: as any*/),
        "reservation.space": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "Space"
        },
        "reservation.space.configuration": {
          "enumValues": [
            "BACE_STOREFRONT_S",
            "BACE_STOREFRONT_M",
            "BACE_STOREFRONT_L",
            "BACE_STOREFRONT_XL",
            "BACE_STOREFRONT_2XL",
            "BACE_SATELLITE_SMALL_STANDARD",
            "BACE_SATELLITE_SMALL_SLIM",
            "BACE_SATELLITE_SMALL_EXTENDED",
            "BACE_SATELLITE_MEDIUM_STANDARD",
            "BACE_SATELLITE_MEDIUM_EXTENDED",
            "BACE_SATELLITE_LARGE_STANDARD",
            "BACE_SATELLITE_LARGE_EXTENDED",
            "BACE_CLATTERING_STANDARD",
            "BACE_TRUCK_HUB_STANDARD",
            "THALIA_RENZ_STANDARD_XS",
            "THALIA_RENZ_STANDARD_S",
            "THALIA_RENZ_STANDARD_M",
            "THALIA_RENZ_WIDE_S",
            "THALIA_RENZ_WIDE_M"
          ],
          "nullable": false,
          "plural": false,
          "type": "SpaceConfiguration"
        },
        "reservation.space.dimensions": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "OutputDimensions"
        },
        "reservation.space.dimensions.depthMm": (v14/*:: as any*/),
        "reservation.space.dimensions.heightMm": (v14/*:: as any*/),
        "reservation.space.dimensions.widthMm": (v14/*:: as any*/),
        "reservation.space.frame": (v18/*:: as any*/),
        "reservation.space.hub": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "Hub"
        },
        "reservation.space.hub.id": (v17/*:: as any*/),
        "reservation.space.id": (v17/*:: as any*/),
        "reservation.space.position": (v14/*:: as any*/),
        "reservation.startedAt": (v20/*:: as any*/),
        "reservation.subtype": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "LockReservationSubtype"
        },
        "reservation.subtype.__typename": (v18/*:: as any*/),
        "reservation.subtype.b2CLockSession": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "B2ClockSession"
        },
        "reservation.subtype.b2CLockSession.amountCollected": (v14/*:: as any*/),
        "reservation.subtype.b2CLockSession.finalAmount": (v16/*:: as any*/),
        "reservation.subtype.b2CLockSession.paymentStatus": {
          "enumValues": [
            "REQUIRES_CAPTURE",
            "REQUIRES_ACTION",
            "COMPLETED"
          ],
          "nullable": true,
          "plural": false,
          "type": "B2ClockSessionPaymentStatus"
        }
      }
    },
    "name": "ended_reservationIdQuery",
    "operationKind": "query",
    "text": "query ended_reservationIdQuery(\n  $hubName: String!\n  $reservationId: UUID!\n) {\n  hubMeta(by: {name: $hubName}) {\n    id\n    name\n    street\n    city\n    postalCode\n    hub {\n      id\n    }\n  }\n  reservation(id: $reservationId) {\n    __typename\n    ... on LockReservation {\n      id\n      startedAt\n      createdAt\n      deactivatedAt\n      contentNote\n      note\n      subtype {\n        __typename\n        ... on B2ClockReservationSubtype {\n          b2CLockSession {\n            finalAmount\n            amountCollected\n            paymentStatus\n          }\n        }\n      }\n      space {\n        id\n        frame\n        position\n        configuration\n        dimensions {\n          widthMm\n          heightMm\n          depthMm\n        }\n        hub {\n          id\n        }\n      }\n    }\n  }\n  b2CLockSession(by: {reservationId: $reservationId}) {\n    id\n    startFee\n    hourlyRate\n    dailyCeiling\n    weekCeiling\n    finalAmount\n    amountCollected\n  }\n}\n"
  }
};
})();

(node as any).hash = "cdc0c17879d1c2fdfa528e77aec807fa";

export default node;
